import React from 'react';
import {useTranslation} from 'react-i18next';
import {
    useSaveVoyageMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/saveVoyage/hooks/useSaveVoyageMutateSingleVoyage";
import PrimaryButtonSingleVoyage
    from "@containers/singleVoyage/ui/buttonts/primaryButtonSingleVoyage/PrimaryButtonSingleVoyage";

const SaveVoyageBtn = () => {

    const {t} = useTranslation()

    const {onSave, isPending} = useSaveVoyageMutateSingleVoyage()

    return (
        <PrimaryButtonSingleVoyage
            sx={{
                flexShrink: 0,
            }}
            onClick={onSave}
            disabled={isPending}
        >
            {t('base.save')}
        </PrimaryButtonSingleVoyage>
    );
};

export default SaveVoyageBtn;